import { render, staticRenderFns } from "./BannerProvider.vue?vue&type=template&id=04f95718&scoped=true&"
import script from "./BannerProvider.vue?vue&type=script&lang=js&"
export * from "./BannerProvider.vue?vue&type=script&lang=js&"
import style0 from "./BannerProvider.vue?vue&type=style&index=0&id=04f95718&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f95718",
  null
  
)

export default component.exports